import api from "../utils/apiServices";

export default function GetData(url) {
  // console.log(url);
  return api.get(url); // Parent component passes the full URL
}
